import { callApi, ENDPOINTS } from 'utils/api/callApi'

interface IDeleteRoutingGuideRequest {
  contractIds: number[]
}

/**
 * Deletes (deprecates) an RG - aka carrier contract lane
 */
export const deleteRoutingGuide = ({ contractIds }: IDeleteRoutingGuideRequest): Promise<void> => {
  return callApi({
    method: 'POST',
    group: 'batch_process_lanes',
    endpoint: ENDPOINTS.contractLanes,
    body: {
      contractLanes: contractIds.map(carrierContractLaneId => ({
        carrierContractLaneId,
        _destroy: true,
      })),
    },
  })
}
